module.exports = __webpack_public_path__ + "static/media/selected.0bdf56a1.png";